import React from 'react'
import styled from 'styled-components'

export interface OrdersPageLayoutProps {
  title: string
  children: React.ReactNode
  className?: string
  /** Max content width. Defaults to 1200px (wide layout used for goods grids). */
  maxWidth?: string
}

const OrdersPageLayout: React.FC<OrdersPageLayoutProps> = ({
  title,
  children,
  className,
  maxWidth = '1200px',
}) => (
  <Page className={className}>
    {/* <Blob $variant='lime' aria-hidden /> */}
    {/* <Blob $variant='soft' aria-hidden /> */}
    <Container $maxWidth={maxWidth}>
      <Header>
        <Title>{title}</Title>
      </Header>
      <Content>{children}</Content>
    </Container>
  </Page>
)

export default OrdersPageLayout

const Page = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.bgLayout};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  isolation: isolate;
`

const Blob = styled.span<{ $variant: 'lime' | 'soft' }>`
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
  z-index: 0;
  ${({ $variant, theme }) =>
    $variant === 'lime'
      ? `
        width: 22.5rem;
        height: 22.5rem;
        background: ${theme.colors.accent};
        opacity: 0.18;
        top: -10rem;
        right: -7.5rem;
      `
      : `
        width: 20rem;
        height: 20rem;
        background: ${theme.colors.accentSoft};
        opacity: 0.55;
        bottom: -7.5rem;
        left: -6.25rem;
      `}
`

const Container = styled.div<{ $maxWidth: string }>`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth};
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  direction: rtl;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0.75rem 0.5rem 0.5rem;
    gap: 0.5rem;
  }
`

const Header = styled.header`
  padding: 0 0.25rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Title = styled.h1`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.sans};
  font-size: ${({ theme }) => theme.text.lg};
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.ink};
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.textMobile.xl};
  }
`

const Content = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`
